import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  IconButton,
  IconNegative,
  IconPlus,
  Text,
} from '@redlink/components/atoms';

export const CounterInput = memo(({ value, onChange, minValue = 0 }) => {
  const { styles, colors } = useStyle();

  return (
    <View>
      <View style={styles.countBlockContainer}>
        <IconButton
          style={styles.countButton}
          disabled={value === minValue}
          onPress={() => {
            onChange && onChange(value - 1);
          }}
        >
          <IconNegative size={24} color={colors.white} />
        </IconButton>
        <Text style={styles.countText}>{value}</Text>
        <IconButton
          style={styles.countButton}
          onPress={() => {
            onChange && onChange(value + 1);
          }}
        >
          <IconPlus size={24} color={colors.white} />
        </IconButton>
      </View>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, ltrFlexDirection }) => ({
  countBlockContainer: {
    alignSelf: 'center',
    minWidth: 200,
    flexDirection: ltrFlexDirection,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.gray7,
    borderRadius: 10,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: colors.gray22,
    height: 48,
  },
  countButton: {
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: 5,
    backgroundColor: colors.blue1,
  },
  countText: {
    fontSize: 16,
    flex: 1,
    textAlign: 'center',
    color: colors.black,
  },
}));
